<template>
    <!-- a played match in short: the competition, the two logos and the score -->
    <article v-if="match" class="result-card" @click="openMatch">
        <header class="result-card__meta">
            <span class="result-card__competition">{{ competition }}</span>
            <span class="result-card__date">{{ date }}</span>
        </header>

        <div class="result-card__row">
            <span class="cl-logo result-card__logo" :title="match.team1.name" @click.stop="goToTeam(match.team1)">
                <img v-if="match.team1.logo" :src="`${assetsUrl}/${match.team1.logo}`" :alt="match.team1.name">
                <v-icon v-else small color="teal">mdi-basketball-hoop</v-icon>
            </span>
            <span class="result-card__score">
                <span :class="{ 'result-card__winner': match.scoreTeam1 > match.scoreTeam2 }">{{ match.scoreTeam1 }}</span>
                <span class="result-card__sep">:</span>
                <span :class="{ 'result-card__winner': match.scoreTeam2 > match.scoreTeam1 }">{{ match.scoreTeam2 }}</span>
            </span>
            <span class="cl-logo result-card__logo" :title="match.team2.name" @click.stop="goToTeam(match.team2)">
                <img v-if="match.team2.logo" :src="`${assetsUrl}/${match.team2.logo}`" :alt="match.team2.name">
                <v-icon v-else small color="teal">mdi-basketball-hoop</v-icon>
            </span>
        </div>

        <footer class="result-card__names">
            <span :class="{ 'result-card__winner-name': match.scoreTeam1 > match.scoreTeam2 }">{{ match.team1.name }}</span>
            <span :class="{ 'result-card__winner-name': match.scoreTeam2 > match.scoreTeam1 }">{{ match.team2.name }}</span>
        </footer>
    </article>
</template>

<script>
    import momentTimezone from 'moment-timezone'

    export default {
        props: {
            match: {
                type: Object,
                default: null
            }
        },
        data() {
            return {
                assetsUrl: 'https://storage.googleapis.com'
            }
        },
        computed: {
            competition() {
                if (this.match.cup) {
                    return this.match.cupLeague ? this.match.cupLeague.title : 'Κύπελλο'
                }
                return this.match.league ? this.match.league.title : 'Friendly'
            },
            date() {
                return this.match.matchDatetime ? momentTimezone(this.match.matchDatetime).tz('Europe/Athens').locale('el').format('ddd D/M · HH:mm') : ''
            }
        },
        methods: {
            openMatch() {
                this.$router.push({ name: 'Match', params: { id: this.match.id } })
            },
            goToTeam(team) {
                this.$router.push({ name: 'Team', params: { id: team.id } })
            }
        }
    }
</script>

<style scoped>
.result-card {
    display: flex;
    flex-direction: column;
    gap: 10px;
    height: 100%;
    padding: 10px 12px 12px;
    border-radius: 10px;
    background: #232323;
    color: #fff;
    font-family: Roboto, Arial, sans-serif;
    text-align: left;
    cursor: pointer;
    border-top: 3px solid rgba(3, 229, 183, 0.6);
    box-shadow: 0 4px 14px rgba(35, 35, 35, 0.12);
    transition: transform 0.15s, box-shadow 0.15s;
}

.result-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 22px rgba(3, 122, 222, 0.2);
}

.result-card__meta {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    font-size: 0.7rem;
    color: rgba(255, 255, 255, 0.55);
}

.result-card__competition {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-weight: 700;
    color: #03e5b7;
}

.result-card__date {
    flex: 0 0 auto;
    text-transform: capitalize;
}

.result-card__row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
}

.result-card__logo {
    width: 42px;
    height: 42px;
}

.result-card__score {
    display: flex;
    align-items: center;
    gap: 6px;
    font-family: 'Squada One', 'Roboto Condensed', Arial, sans-serif;
    font-size: 1.9rem;
    line-height: 1;
    color: rgba(255, 255, 255, 0.55);
}

.result-card__winner {
    color: #fff;
}

.result-card__sep {
    color: rgba(255, 255, 255, 0.3);
}

.result-card__names {
    display: flex;
    justify-content: space-between;
    gap: 10px;
    font-size: 0.72rem;
    color: rgba(255, 255, 255, 0.6);
}

.result-card__names span {
    max-width: 48%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.result-card__names span:last-child {
    text-align: right;
}

.result-card__winner-name {
    color: #fff;
    font-weight: 700;
}
</style>
